import type { SvgProps } from '@manomano-internal/tamagoshi-icons/esm/SvgOptimizer/Svg';
import type { FC } from 'react';

import { EnergyLabelA } from './EuEnergyLabels/EnergyLabelA';
import { EnergyLabelB } from './EuEnergyLabels/EnergyLabelB';
import { EnergyLabelC } from './EuEnergyLabels/EnergyLabelC';
import { EnergyLabelD } from './EuEnergyLabels/EnergyLabelD';
import { EnergyLabelE } from './EuEnergyLabels/EnergyLabelE';
import { EnergyLabelF } from './EuEnergyLabels/EnergyLabelF';
import { EnergyLabelG } from './EuEnergyLabels/EnergyLabelG';

interface EuEnergyLabelProps {
  label: string;
  onClick?: () => void;
  className?: string;
}

const energyLabelComponents: Record<string, FC<SvgProps>> = {
  A: EnergyLabelA,
  B: EnergyLabelB,
  C: EnergyLabelC,
  D: EnergyLabelD,
  E: EnergyLabelE,
  F: EnergyLabelF,
  G: EnergyLabelG,
};

export const EuEnergyLabel: FC<EuEnergyLabelProps> = ({ label, ...props }) => {
  const EnergyLabel = energyLabelComponents[label];

  return <EnergyLabel {...props} />;
};

EuEnergyLabel.displayName = 'EuEnergyLabel';
